import React, { useState } from "react";
import Modal from "../Modal";

export default function ModalCrearMiembro({ token, onClose, onSave }) {
  const [miembro, setMiembro] = useState({
    nombre: "",
    paterno: "",
    materno: "",
    direccion: "",
    telefonos: "",
    email: "",
    nacimiento: "",
    aniversario: "",
    sexo: "",
  });
  const [loading, setLoading] = useState(false);

  const inputClass =
    "w-full border border-slate-200 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400";

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const res = await fetch("/api/miembros", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(miembro),
      });

      if (!res.ok) throw new Error("No se pudo crear el miembro");
      onSave(); // refresca tabla
      onClose();
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={true} onClose={onClose} title="Nuevo miembro" maxWidth="max-w-lg">
      <div>
        <div className="space-y-3">
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">
              Nombre <span className="text-rose-500">*</span>
            </label>
            <input
              className={inputClass}
              placeholder="Nombre"
              value={miembro.nombre}
              onChange={(e) => setMiembro({ ...miembro, nombre: e.target.value })}
            />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-medium text-slate-700 mb-1">Apellido paterno</label>
              <input
                className={inputClass}
                placeholder="Apellido paterno"
                value={miembro.paterno}
                onChange={(e) => setMiembro({ ...miembro, paterno: e.target.value })}
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-slate-700 mb-1">Apellido materno</label>
              <input
                className={inputClass}
                placeholder="Apellido materno"
                value={miembro.materno}
                onChange={(e) => setMiembro({ ...miembro, materno: e.target.value })}
              />
            </div>
          </div>

          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">Sexo</label>
            <select
              className={inputClass}
              value={miembro.sexo}
              onChange={(e) => setMiembro({ ...miembro, sexo: e.target.value })}
            >
              <option value="">-- Selecciona --</option>
              <option value="M">Masculino</option>
              <option value="F">Femenino</option>
            </select>
          </div>

          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">Dirección</label>
            <input
              className={inputClass}
              placeholder="Dirección"
              value={miembro.direccion}
              onChange={(e) => setMiembro({ ...miembro, direccion: e.target.value })}
            />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-medium text-slate-700 mb-1">Teléfonos</label>
              <input
                className={inputClass}
                placeholder="Teléfonos"
                value={miembro.telefonos}
                onChange={(e) => setMiembro({ ...miembro, telefonos: e.target.value })}
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-slate-700 mb-1">Correo electrónico</label>
              <input
                className={inputClass}
                type="email"
                placeholder="Correo electrónico"
                value={miembro.email}
                onChange={(e) => setMiembro({ ...miembro, email: e.target.value })}
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-xs font-medium text-slate-700 mb-1">Nacimiento</label>
              <input
                className={inputClass}
                type="date"
                value={miembro.nacimiento}
                onChange={(e) => setMiembro({ ...miembro, nacimiento: e.target.value })}
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-slate-700 mb-1">Aniversario</label>
              <input
                className={inputClass}
                type="date"
                value={miembro.aniversario}
                onChange={(e) => setMiembro({ ...miembro, aniversario: e.target.value })}
              />
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-2 mt-4 pt-3 border-t border-slate-100">
          <button
            onClick={onClose}
            className="px-3.5 py-1.5 text-sm rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 transition"
          >
            Cancelar
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="px-3.5 py-1.5 text-sm rounded-lg bg-indigo-600 hover:bg-indigo-700 disabled:opacity-60 text-white font-medium transition"
          >
            {loading ? "Guardando..." : "Guardar"}
          </button>
        </div>
      </div>
    </Modal>
  );
}
